import React from "react";
import ReactDOM from "react-dom";
import * as Helper from "../helpers.mjs";
import {openModal, notifyError, notifyLoading, stopNotifyLoading, LoadingNotification, ErrorNotification, AddEntityModal, closeModal} from "../modal.js";
import {fetchJson, fetchJsonNoModals} from "../fetch.js";
import {PubSub,reattachEventListener} from '../weave/helpers.mjs';
import OrderingGridModal from "./orderingGridModal.mjs";
import Drawer from "./drawer.js";
import "whatwg-fetch";
// import 'promise-polyfill/src/polyfill.js';
import Promise from 'promise-polyfill';

class BasketHeader extends React.Component {
    render() {
        var basket = this.props.basket;
        const isFurniture = this.props.isFurniture;
        var link = this.props.link;

        if (!basket) {
            basket = {
                name: isFurniture ? 'Furniture order' : 'Basket',
                quantity: 0,
                total: "0.00"
            };
            link = "/basket";
        }

        var classes = "basketHeader";
        
        if (isFurniture) {
            classes += " furniture";
            if (Number(basket.quantity) === 0) {
                link = "#";
            } else {
                link = "/furniture/checkout";
            }
        } else if(basket.type) {
            classes += " " + basket.type;            
        }

        if (!link && basket) {
            link = "/basket/checkout";
        }

        const clickheader = () => {
            if (isFurniture && Number(basket.quantity) === 0) {
                notifyError("Your furniture order is currently empty");
            }
        }

        return (<>
            <a href={link} onClick={clickheader}>
                <div className={classes}>
                    <div className="orderDetails">
                        <div className="currentBasket">
                            {(!!this.props.loaded && basket &&
                            <p className="nameQtyContainer">
                                <span className="basketName">{basket.name}</span>
                                <span className="basketValue">
                                    <span className="basketQuantity">{basket.quantity} {basket.quantity === 1 ? 'item' : 'items'}</span>
                                    <span className="basketDivider">|</span>
                                    <span className="basketTotal">{Helper.currency(basket.total)}</span> {/* !isFurniture ? Helper.currency(basket.total) : Helper.currency(basket.subtotal) */}
                                </span>
                            </p>) || <div>Loading<span>.</span><span>.</span><span>.</span></div>}
                        </div>
                    </div>
                </div>
            </a>
        </>);
    }
}

class DummyChannel {
    postMessage() {

    }
}

class App extends React.Component {
    constructor(props) {
        super(props);

        this.activate = this.activate.bind(this);
        this.rename = this.rename.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.delete = this.delete.bind(this);
        this.addBasket = this.addBasket.bind(this);
        this.changeName = this.changeName.bind(this);

        this.wantOrderingGrid = null;
        this.wantOrderingGridBookshelf = null;
        this.wantOrderingGridBasketBuilder = null;
        this.wantAddPageToBookshelf = null;
        this.ogcontroller = null;

        const path = window.location.pathname.split("/");
        this.isFurniture = path[1] == 'furniture' ? '1' : 0;
        this.isManageBaskets = (path[1] == 'basket' && path[2] == 'manage') || path[1] == 'manage-baskets';

        if (path[1] == 'logout') {
            // we will redirect so there's no point loading the basket data - it will just error
        }

        this.state = {
            activeBasketId: null,
            furnitureBasketId: null,
            baskets: {},
            loaded: false,
            orderingGrid: null,
            preloaded: null,
            orderingGridData: [],
            libsOrder: null,
            drawer: "closed",
            bookshelfId: 0,
            basketBuilderData: [],
            basketBuilderType: "forSchools",
            ordering: false,
            bookshelves: [],
            canCommit: null,
        };

        // check for browser support
        if (typeof BroadcastChannel != "undefined") {
            this.channel = new BroadcastChannel("baskets");
            this.channel.addEventListener("message", m => {
                this.setState({
                    baskets: m.data
                });
            });
            this.activechannel = new BroadcastChannel("activeBasket");
            this.activechannel.addEventListener("message", m => {
                this.setState({
                    activeBasketId: m.data
                });
            });
        } else {
            this.channel = new DummyChannel();
            this.activechannel = new DummyChannel();
        }

        $('body').on('click', '.addToBasket:not(.bookshelfButton)', this.addProductWrapper.bind(this));
        $('body').on('click', '.addToFurnitureBasket', this.addFurnitureFromSearch.bind(this));

        if (this.isFurniture) {
            $('body').on('click', '#addToBasket', this.addFurniture.bind(this));
        }
        $('body').on('click', '.addPageToBasketSubmit', this.addPageToBasket.bind(this));
        $('body').on('click', '#addSelectedToBasket', this.addSelectedToBasket.bind(this));
        $('body').on('click', '#addAllWishlistToBasket', this.addAllWishlistToBasket.bind(this));
        $('body').on('click', '.removeFromBasket', this.removeFromBasket.bind(this));

        $('body').on('click', '#deleteBasketPopup .popupCancel', function(){
            $('#deleteBasketPopup').fadeOut();
        });

        PubSub.sub("wantAddToBookshelf", prId => {
            this.wantAddToBookshelf = prId;
        });

        PubSub.sub("updateBasketBranch", this.updateBasketBranch.bind(this));
        PubSub.sub("updateBasketBranchAll", this.updateBasketBranchAll.bind(this));
        PubSub.sub("addToBasketBranch", this.addToBasketBranch.bind(this));
        PubSub.sub("updateLabel", this.updateLabel.bind(this));
        PubSub.sub("updateDiscount", this.updateDiscount.bind(this));
        PubSub.sub("saveOrderingGrid", this.saveOrderingGrid.bind(this));
        PubSub.sub("legacyReloadBaskets", this.reloadData.bind(this));
        PubSub.sub("openOrderingGrid", this.openOrderingGrid.bind(this));
        PubSub.sub("loadOrderingGrid", this.fetchOrderingGridData.bind(this));
        PubSub.sub("openAddBasketModal", this.openAddBasketModal.bind(this));
        PubSub.sub("openAddForSchoolBasketModal", this.openAddForSchoolBasketModal.bind(this));
    }

    componentWillUnmount() {
        PubSub.clearsub("wantAddToBookshelf");
        PubSub.clearsub("updateBasketBranch");
        PubSub.clearsub("updateBasketBranchAll");
        PubSub.clearsub("addToBasketBranch");
        PubSub.clearsub("updateLabel");
        PubSub.clearsub("updateDiscount");
        PubSub.clearsub("saveOrderingGrid");
        PubSub.clearsub("legacyReloadBaskets");
        PubSub.clearsub("openOrderingGrid");
        PubSub.clearsub("loadOrderingGrid");
    }

    loadData(totals = false) {
        const path = window.location.pathname.split("/");
        if (path[1] == "logout") {
            return;
        }
        if(totals) {
            return fetchJson("/basket/data/1").then(this.init.bind(this));
        } else {
            this.loadData(true)
            return fetchJson("/basket/data").then(this.init.bind(this));
        }
    }

    reloadData() {
        this.setState({
            loaded: false
        });
        this.loadData().then(r => {
            stopNotifyLoading();
            var baskets = this.state.baskets
            this.channel.postMessage(baskets);
        });
    }

    async fetchOrderingGridData(basketId, prId) {
        if (basketId === null) {
            basketId = this.state.activeBasketId;
            if (!basketId) {
                return;
            }
        }
        if (basketId == "new") {
            return;
        }

        return fetchJsonNoModals("/basket/orderingGrid/" + basketId + "/" + prId).then(r => {
            var index = this.state.orderingGridData.findIndex(d => d && d.basketId === basketId && d.prId === prId);

            if (index !== -1) {
                this.setState(state => {
                    var newData = state.orderingGridData;
                    newData[index] = r;
                    return {
                        orderingGridData: newData
                    };
                });
            } else {
                this.setState(state => ({
                    orderingGridData: [...state.orderingGridData, r]
                }));

                index = this.state.orderingGridData.findIndex(d => d && d.basketId === basketId && d.prId === prId);
            }

            if (index < 0) {
                return;
            }

            this.setState(state => ({
                preloaded: index
            }));
        }).catch(e => {
            console.log(e); // don't do anything on error because it's a bg process
        });
    }

    countBaskets(baskets) {
        var a = [];
        for (var id in baskets) {
            a.push(baskets[id]);
        }
        return a.length ? a.filter(b => !b.deleted && b.type != "Furniture").length : 0;
    }

    orderingGridInit(index) {
        this.setState({
            orderingGrid: index
        }, () => {
            openModal("addToBasketModal");
        });
        // PubSub.pub("orderingGridInit", this.orderingGridData[index]);
    }

    getOrderingGridData(basketId = null, prId = null) {
        if (basketId && prId) {
            return this.state.orderingGridData.find(d => d && d.basketId === basketId && d.prId === prId);
        }
        if (this.state.orderingGrid !== null) {
            return this.state.orderingGridData[this.state.orderingGrid];
        }
        if (this.state.preloaded !== null) {
            return this.state.orderingGridData[this.state.preloaded];
        }
    }

    getItemTotal(basketId, prId) {
        const data = this.getOrderingGridData(basketId, prId);
        if (!data) {
            return null;
        }

        return data.data.reduce((prev, cur) => prev + Number(cur.price)*Number(cur.quantity), 0);
    }

    getItemServicingTotal(basketId, prId) {
        const data = this.getOrderingGridData(basketId, prId);
        if (!data) {
            return null;
        }

        return data.data.reduce((prev, cur) => prev + Number(cur.servicing)*Number(cur.quantity), 0);
    }

    getItemQuantity(basketId, prId) {
        const data = this.getOrderingGridData(basketId, prId);
        if (!data) {
            return null;
        }

        return data.data.reduce((prev, cur) => prev + Number(cur.quantity), 0);
    }

    saveOrderingGrid(prId, newTotalQuantity=null) {
        const data = this.getOrderingGridData();
        // const bsId = data.basketId;
        var totalItems = newTotalQuantity;
        if (totalItems === null) {
            totalItems = data.data.reduce((prev, cur) => prev + Number(cur.quantity), 0);
        }
        // const totalCost = data.data.reduce((prev, cur) => prev + Number(cur.price)*Number(cur.quantity), 0);

        $(".addToBasket[prid="+data.prId+"]").parent().find(".addToBasketSelect").find('option:selected').data("inbasket", totalItems);
        if (totalItems > 0) {
            $(".addToBasket[prid="+data.prId+"]").parent().find(".addToBasketSelect").find('option:selected').attr("inbasket", true);
        } else {
            $(".addToBasket[prid="+data.prId+"]").parent().find(".addToBasketSelect").find('option:selected').attr("inbasket", false);
        }

        // have to reload from server because we can't recalculate easily if quantities were decreased
        this.reloadData();

        PubSub.pub("basketItemUpdate", data.prId, data.basketId, totalItems);
    }

    updateBasketBranchAll(branchId, field, value, basketId) {
        this.setState(state => {
            var data = state.orderingGridData;
            data.filter(d => d.basketId == basketId).forEach(d => {
                var bb = d.data.find(b => b.branchId === branchId);
                if (!bb) {
                    return;
                }
                bb[field] = value;
            });
            return {
                orderingGridData: data
            };
        });
    }

    updateBasketBranch(branchId, field, value) {
        const index = this.state.orderingGrid;

        // Validate quantity? (maximum of 999)
        if (field == "quantity" && value > 999) {
            value = 999;
        }

        this.setState(state => {
            var data = state.orderingGridData;
            var bb = data[index].data.find(b => Number(b.branchId) === Number(branchId));
            if (!bb) {
                return {};
            }
            bb[field] = value;
            return {
                orderingGridData: data
            };
        });

        // PubSub.pub("orderingGridInit", this.orderingGridData[index]);
    }

    addToBasketBranch(branchId, field, value) {
        const index = this.state.orderingGrid;

        // Validate quantity? (maximum of 999)
        if (field == "quantity" && value > 999) {
            value = 999;
        }

        this.setState(state => {
            var data = state.orderingGridData;
            var bb = data[index].data.find(b => Number(b.branchId) === Number(branchId));
            if (!bb) {
                return {};
            }
            var currentValue = bb[field];
            var newValue = Number(value) + Number(currentValue);
            bb[field] = newValue;
            return {
                orderingGridData: data
            };
        });
    }

    updateLabel(value, prId=null) {
        var index = this.state.orderingGrid;
        if (prId) {
            index = this.state.orderingGridData.findIndex(i => i.prId === prId);
        }
        if (index < 0) {
            return;
        }
        this.setState(state => {
            var data = state.orderingGridData;
            data[index].label = value;
            return {
                orderingGridData: data
            };
        });

        // PubSub.pub("orderingGridInit", this.orderingGridData[index]);
    }

    updateDiscount(value, prId=null) {
        var index = this.state.orderingGrid;
        if (prId) {
            index = this.state.orderingGridData.findIndex(i => i.prId === prId);
        }
        if (index < 0) {
            return;
        }
        this.setState(state => {
            var data = state.orderingGridData;
            data[index].discount = value;
            return {
                orderingGridData: data
            };
        });
    }

    updateLoadingStatus(value, index, overwrite = false) {
        if (this.state.orderingGridData[index].loading == 'Error') {
            return;
        }
        this.setState(state => {
            var data = state.orderingGridData;
            if (overwrite) {
                data[index].loading = value;
            } else {
                data[index].loading += value;
            }
            return {
                orderingGridData: data
            };
        });
    }

    getOrderTrackData(basketId, prId, index) {
        fetchJson("/basket/orderTrackData/" + basketId + "/" + prId).then(r => {
            r.forEach(result => {
                this.setState(state => {
                    var i = state.orderingGridData[index].data.findIndex(b => b.branchId === result.branchId);
                    var data = state.orderingGridData;
                    data[index].data[i] = Object.assign({}, data[index].data[i], result);
                    return {
                        orderingGridData: data
                    };
                });
            });
            this.updateLoadingStatus("Done", index);
        }).catch(r => {
            this.updateLoadingStatus("Error", index);
        });
    }

    getBranchTotals(basketId, index) {
        fetchJson("/basketBranch/totals/" + basketId).then(r => {
            r.forEach(result => {
                this.setState(state => {
                    var i = state.orderingGridData[index].data.findIndex(b => b.branchId === result.branchId);
                    var data = state.orderingGridData;
                    data[index].data[i] = Object.assign({}, data[index].data[i], result);
                    return {
                        orderingGridData: data
                    };
                });
            });
            this.updateLoadingStatus("Done", index);
        }).catch(r => {
            this.updateLoadingStatus("Error", index);
        });
    }

    openOrderingGrid(basketId, prId, bookshelfId=0, basketBuilderData=[]) {
        if (basketId == "new" || basketId == 0) {
            this.wantOrderingGrid = prId;
            this.wantOrderingGridBookshelf = bookshelfId;
            if (basketBuilderData.length > 0) {
                this.setState(state => ({
                    basketBuilderData: basketBuilderData,
                }));
            }
            this.wantOrderingGridBasketBuilder = basketBuilderData;
            return this.addBasket();
        } else if (basketId == "active") {
            basketId = this.state.activeBasketId;
        }

        notifyLoading();

        if (this.ogcontroller !== null) {
            this.ogcontroller.abort();
        }
        this.ogcontroller = new AbortController();

        fetchJson("/basket/orderingGrid/" + basketId + "/" + prId, null, {signal: this.ogcontroller.signal}).then(r => {
            this.setState(state => ({
                orderingGridData: [r],
                bookshelfId: bookshelfId,
                basketBuilderData: basketBuilderData,
            }), () => {
                const index = this.state.orderingGridData.length - 1;
                this.orderingGridInit(index);
                stopNotifyLoading();

                // this.getOrderTrackData(basketId, prId, index);
                // this.getBranchTotals(basketId, index);
            });
            
        }).catch(error => {
            PubSub.pub("orderingGridModal_close");
        });
    }

    openAddBasketModal(basketType, basketBuilderData) { // Used on advanced search page? (SCHOOLS MODE)
        notifyLoading();
        var modalName = "";
        if (basketType == "regular") {
            modalName = "addBasket";
        } else if (basketType == "forSchools") {
            modalName = "addForSchoolBasket";
        }
        if (basketBuilderData.length > 0) {
            this.setState(state => ({
                basketBuilderType: basketType,
                basketBuilderData: basketBuilderData,
            }), () => {
                const modal = document.getElementById(modalName);
                modal.classList.add("active");
                if (basketType == "regular") {
                    this.initBasketModal();
                } else if (basketType == "forSchools") {
                    this.prepForSchoolBasketModal();
                    this.setBasketBuilderRelatedInputs(modalName);
                }
                stopNotifyLoading();
            });
            var confirm = document.querySelector("#" + modalName + " .modal-footer .btn[data-action='confirm']");
            reattachEventListener(confirm, 'click', this.submitBasketBuilderData.bind(this));
            var closeButtons = document.querySelectorAll(".modal [aria-label='Close']");
            closeButtons.forEach(el => {
                el.addEventListener('click', e => {
                    const modal = e.target.closest(".modal");
                    modal.classList.remove("active");
                });
            });
            $('body').find('#basketDraw').css('left', 'calc(100% - '+($('#basketDrawItems').outerWidth())+'px)');
        } else {
            stopNotifyLoading();
        }
    }

    openAddForSchoolBasketModal(basketType, basketBuilderData) { // Used on boolean search page? (LIBS MODE)
        if (basketBuilderData.length > 0) {
            this.setState(state => ({
                basketBuilderType: basketType,
                basketBuilderData: basketBuilderData,
            }));
        }
        const container = document.getElementById('addForSchoolBasketModal');
        notifyLoading();
        fetch("/basket/addForSchoolBasketModal").then(r => r.text()).then(r => {
            stopNotifyLoading();
            container.innerHTML = r;
            
            const modal = document.getElementById("addForSchoolBasket");
            modal.classList.add("active");
            this.prepForSchoolBasketModal();
            this.setBasketBuilderRelatedInputs("addForSchoolBasket");
            var confirm = document.querySelector("#addForSchoolBasket .modal-footer .btn[data-action='confirm']");
            reattachEventListener(confirm, 'click', this.submitBasketBuilderData.bind(this));

            $('body').find('#basketDraw').css('left', 'calc(100% - '+($('#basketDrawItems').outerWidth())+'px)');
        });
    }

    async submitBasketBuilderData(r) {
        notifyLoading('Saving...');

        var modalName = "";
        var basketType = this.state.basketBuilderType;
        if (basketType == "regular") {
            modalName = "addBasket";
        } else if (basketType == "forSchools") {
            modalName = "addForSchoolBasket";
        }

        var formElement = document.querySelector('#' + modalName + ' #addBasketForm');
        var formData = new FormData(formElement);
        var basketName = document.querySelector('#' + modalName + ' #basketName_');

        if (!this.validateForm(formElement)) {
            return;
        }

        fetchJson("/basket/add", formData).then(result => {
            document.getElementById(modalName).classList.remove("active");
            this.addNewBasket(result, basketName.value);
        }).then(() => {
            var bbData = this.state.basketBuilderData;
            var url = "/search/fromBasketBuilder/" + bbData[0].basketValue;
            if (bbData[0].profileId) {
                url += "/" + bbData[0].profileId;
            } else {
                var defaultProfileId = 0; // NO PROFILE ID SELECTED
                url += "/" + defaultProfileId;
            }
            url += "/" + this.state.activeBasketId;

            var bbFormData = new FormData();
            var basketBuilderClass = $("#basketBuilderModal").attr("class");
            // Basket builder via boolean search page
            if (basketBuilderClass == "booleanBasketBuilder") {
                updateFilterItemArray();
                bbFormData.append("searchFilterItems", JSON.stringify(filterItems));
                bbFormData.append("searchPageType", "boolean");
            }
            // Basket builder via advanced search page
            else if (basketBuilderClass == "advancedBasketBuilder") {
                const advancedSearchFormData = new FormData($('#searchForm')[0]);
                for (var pair of advancedSearchFormData.entries()) {
                    bbFormData.append(pair[0], pair[1]);
                }
                bbFormData.append("searchPageType", "advanced");
            }
            fetchJson(url, bbFormData).then(r => {
                if (r.error) {
                    notifyError(r.error); // "No search filters" for example
                }
                // stopNotifyLoading();
                loadBasketDraw();
            });
        });
    }

    onDelete(e) {
        $('#deleteBasketPopup').fadeIn()
        var delBsId = $(e.currentTarget).parents('.basket').data('id');
        var delBsName = $(e.currentTarget).parents('.basket').find('.basketName').val() ? $(e.currentTarget).parents('.basket').find('.basketName').val() : $(e.currentTarget).parents('.basket').find('.basketName').text();
        $(".basketNameContainer").html(delBsName);

        $('#deleteBasketPopup .popupConfirm').off("click");
        $('#deleteBasketPopup .popupConfirm').on('click', e => {
            this.delete.bind(this, delBsId).call();
        });
    }

    delete(delBsId) {
        fetchJson("/basket/delete/" + delBsId).then(r => {
            $('#deleteBasketPopup').fadeOut();

            var baskets = this.state.baskets;
            baskets[delBsId].deleted = true;
            this.setState({
                baskets: baskets,
                activeBasketId: r.activeBasket
            });
            this.channel.postMessage(baskets);
            this.activechannel.postMessage(r.activeBasket);

            $('.addToBasketSelect').each(function(){
                $(this).find('option[value="'+delBsId+'"]').remove();
            });

            if (this.countBaskets(baskets) === 0) {
                $('.addToBasketSelect').find(":selected").prop('selected', false)
                $('.addToBasketSelect').each(function(){
                    $(this).append('<option selected value="new">Basket</option>');
                });
            }

            // this.layout();
        });
    }

    changeName(e, id) {
        this.setState(state => {
            state.baskets[id].name = e.target.value;
            return state;
        });
    }

    rename(e) {
        const input = e.currentTarget;
        var basketId = input.closest('tr').dataset.id;

        var url = "/basket/rename/" + basketId;
        var formData = new FormData();
        formData.append("name", input.value);

        fetch(url, {
            method: 'POST',
            body: formData
        }).then(r => r.json()).then(r => {
            if (r.error) {
                return Helper.notifyError(r.error);
            }

            var baskets = this.state.baskets;
            baskets[basketId].name = input.value;
            this.setState({
                baskets: baskets
            });
            this.channel.postMessage(baskets);

            $('.addToBasketSelect').each(function(){
                $(this).find('option[value="'+basketId+'"]').text(input.value);
            });
        })
    }

    addFurnitureFromSearch(e) {
        var addToBasketButton = $(this);
        var qtyInput = $(this).parents('.productContainer').find('.productQty');
        var qty = qtyInput.val();
        if (qty <= 0) {
            return qtyInput.effect( "shake",{distance:5} );
        }

        var fuId = $(this).data('id');
        addToBasketButton.addClass('added');

        var bsId = this.state.furnitureBasketId;
        if (!bsId) {
            bsId = $('#furnitureBasketInfo').val() > 0 ? $('#furnitureBasketInfo').val(): "";
        }
        
        $.ajax({
            method: 'POST',
            cache: false,
            url: '/furniture/addToBasket/' + bsId + '/' + fuId + '/' + qty
        }).done(function(result) {
            if (!result.success) {
                return;
            }
            addToBasketButton.removeClass('added');
            addToBasketButton.find('.wishlistText').text('ADD MORE');

            var baskets = this.state.baskets;
            baskets[bsId].quantity += Number(qty);
            baskets[bsId].total = result.newTotal;
            this.setState({
                baskets: baskets
            });

            this.channel.postMessage(baskets);
        });
    }

    addFurniture(e) {
        var qty = $('#qty').val();
        var fuId = $('.productContainer').first().data('id');
		var address = null;
        var bsId = this.state.furnitureBasketId;
        if (!bsId) {
            bsId = $('#furnitureBasketInfo').val() > 0 ? $('#furnitureBasketInfo').val(): "";
        }
        if (!fuId) {
            return Helper.notifyError("Invalid furniture item");
        }

		if ($.isNumeric(qty) && qty > 0) {
			if ($('#configurations').length) {
				var array = $('#configurations').serializeArray().filter(function(v) {
					return v.value !== ''
				});

				if($('#configurations .options.field').length == array.length) {
					address = '/furniture/addToBasket/'+bsId+'/'+fuId+'/'+qty+'/'+$('#configurations :input[value!=""]').serialize();
				}	
			} else {
				address = '/furniture/addToBasket/'+bsId+'/'+fuId+'/'+qty;
			}

			if (address) {
				$('#configurations').find('.errorMessage').stop().fadeOut('fast');

				var button = $(e.target);
				button.html('Adding&hellip;')
				
				fetchJson(address)
				.then(response => {
					button.html('Added');
                    if (!bsId) { // means there was no furniture basket
                        this.loadData();
                    } else {
                        var baskets = this.state.baskets;
                        baskets[bsId].quantity += Number(qty);
                        baskets[bsId].total = response.newTotal;
                        this.setState({
                            baskets: baskets
                        });
                    }

                    this.channel.postMessage(baskets);

					setTimeout(function() { 
						button.html('Add to Furniture Order');
					}, 8000);
				});
			} else {
				$('#configurations').find('.errorMessage').stop().fadeIn('fast');
			}
		}
    }

    // on wishlist page
    addSelectedToBasket() {
        var checkedInputs = $('.wishListItems .checkMarkInput:checked');
        var checkedItems = checkedInputs.parents('.productContainer');

        return this.addMultipleToBasket(checkedItems);
    }

    addAllWishlistToBasket() {
        fetchJson('/basket/addAllWishlist').then(result => {
            if (result.notAdded) {
                if(result.notAdded.unavailable) {
                    const message = result.notAdded.unavailable.map(u => <li style={{textAlign:"left"}}>{u}</li>);
                    notifyError("The following unavailable titles were not added", <ul>{message}</ul>).then(() => {
                        window.location.replace("/basket/checkout");
                    });
                } else {
                    notifyError("The following unavailable titles were not added", <ul>{`Couldn't find titles.`}</ul>).then(() => {
                        window.location.replace("/basket/checkout");
                    });
                }
            } else {
                window.location.replace("/basket/checkout");
            }
        });
    }

    addPageToBasket() {
        $('.loadingText').text('Adding to basket...')
        $('#listLoadOverlay').stop().fadeIn('fast')

       
        var searchItems = ($('.addPage').val()).split(",");

        return this.addMultipleToBasket(searchItems);
    }

    addMultipleToBasket(searchItems) {
        var availableItems = searchItems.find('.addButtonContainer:not(.disabled)');
        if (availableItems.length == 0) {
            if (searchItems.length == 1) {
                notifyError("Cannot add this title as it is unavailable to order");
            } else {
                notifyError("Cannot add these titles as they are unavailable to order");
            }
            $('#listLoadOverlay').stop().fadeOut('fast');
            return;
        }

        var itemsToAdd = [];
        searchItems.each(function(){
            var itemDetails = {
                id: $(this).data('prid'),
                qty: $(this).find('.productQty').val()
            }
            if (itemDetails.id) {
                itemsToAdd.push(itemDetails);
            }
        });

        const basketId = this.state.activeBasketId ? this.state.activeBasketId : "new";

        fetchJson('/basket/addArray/' + basketId, {
            items: itemsToAdd
        }).then(result => {
            if (result.notAdded) {
                if(result.notAdded.unavailable) {
                    const message = result.notAdded.unavailable.map(u => <li style={{textAlign:"left"}}>{u}</li>);
                } else {
                    const message = "Couldn't find titles.";
                }
                notifyError("The following unavailable titles were not added", <ul>{message}</ul>).then(() => {
                    window.location.replace("/basket/checkout");
                });
            } else {
                window.location.replace("/basket/checkout");
            }
        });
    }

    addPageToBookshelfCallback(results) {
        stopNotifyLoading();
    }

    removeFromBasket(e) {
        var bsId = $('#basketFilter').val();
        var prId = $(e.currentTarget).data('prid');
        
        if(!bsId) {
            bsId = $(e.currentTarget).next('.addToBasketSelectWrapper').find('.addToBasketSelect').val();
        }

        notifyLoading();
        if(bsId > 0 && prId > 0) {
            fetchJson("/basket/remove/" + bsId + "/" + prId).then(r => {
                PubSub.pub("basketItemUpdate", prId, bsId, 0, false);
                this.loadData().then(r => {
                    stopNotifyLoading();
                });
            });
        } else {
            alert('Failed to remove item.');
        }
    }

    addBookshelfCallback(r) {
        var bookshelves = [...this.state.bookshelves];
        bookshelves.push({
            bksId: r.bookshelfId,
            bksName: r.name,
        });
        
        this.setState({bookshelves: bookshelves}, () => {
            PubSub.pub("basketUpdate", this.state.baskets, this.state.activeBasketId, bookshelves);

            var prId = this.wantAddToBookshelf;
            
            if (prId) {
                fetchJson("/bookshelves/addProduct/" + r.bookshelfId + "/" + prId)
                .then(() => {
                    PubSub.pub("addedToNewBookshelf", prId, r.bookshelfId);
                    this.wantAddToBookshelf = null;
                });
            } else {
                PubSub.pub("addPageToBookshelf", r.bookshelfId);
            }
        });
    }

    addProductWrapper(e) {
        try {
            this.addProduct.bind(this)(e);
        } catch (e) {
            notifyError("The following error occurred", e.message);
            console.error(e.name + ': ' + e.message);
        }
    }

    addProduct(e) {
        var basketSelect = $(e.currentTarget).siblings('.addToBasketSelectWrapper').find('.addToBasketSelect');
        var selectedBasketId = basketSelect.val();
        // var addToBasketButton = $(e.currentTarget);
        // var selectedBasketOption = basketSelect.find(':selected');
        var qtyInput = $(e.currentTarget).parents('.productContainer').find('.productQty');

        var prId = $(e.currentTarget).attr('prid');

        if (Helper.isLibraryUser() && Helper.isForSchoolBasket() === false) {
            return this.openOrderingGrid(selectedBasketId, prId);
        }

        var price;
        const searchprice = $(e.currentTarget).parents('.productContainer').find('.searchPrice');
        if (!searchprice.length) {
            // book page
            price = $(e.currentTarget).parents('.productContainer').find('.bookPrice').text().substr(1);
        } else {
            // search page (or page with embedded products?)
            price = searchprice.text().substr(1);
        }

        const quantity = Number(qtyInput.val());

        if(qtyInput.val() > 0) {
            var url = "/basket/addProduct/" + selectedBasketId + "/" + $(e.currentTarget).attr('prid') + "/" + price + "/" + quantity;
            fetchJson(url).then(r => {
                // addToBasketButton.addClass('added');
                // selectedBasketOption.attr("inbasket", true);
                var basketId = r.basketId;
                // setTimeout(function() {
                //     addToBasketButton.removeClass('added');
                //     addToBasketButton.find('.wishlistText').text('ADD MORE');
                // }, 4000);
                // $('option[value="new"]').val(basketId);

                if (selectedBasketId == "new") {
                    var basketIdInput = $('body').find('#activeBasketId');
                    if (basketIdInput.length > 0) {
                        basketIdInput.val(r.activeBasketId);
                        const newBasketId = basketIdInput.val();

                        $('body').find('.addToBasketSelect').each(function(){
                            $(this).find('option[value="new"]').val(newBasketId);
                        });

                        $('body').find('.addToBasketSelect').each(function(){
                            $(this).find('option[value="'+newBasketId+'"]').prop('selected', true);
                        });
                    }
                }

                var baskets = this.state.baskets;
                if (!baskets[basketId]) {
                    baskets[r.basketId] = {
                        id: r.basketId,
                        name: 'Basket',
                        quantity: 0,
                        total: '0.00',
                        checkout: '/basket/checkout',
                    };
                }

                baskets[basketId].quantity += quantity;
                var total = Number(baskets[basketId].total);
                total += Number(price) * quantity;
                baskets[basketId].total = total;
                
                this.setState({
                    baskets: baskets,
                    activeBasketId: r.activeBasketId
                });
                this.channel.postMessage(baskets);

                $('body').find('#basketDraw').css('left', 'calc(100% - '+($('#basketDrawItems').outerWidth())+'px)');
                // this.layout();
                
                PubSub.pub("basketItemUpdate", prId, basketId, Number(quantity), true);
            });
        } else {
            qtyInput.effect("shake", {distance:5});
        }
    }

    validateForm(formElement) {
        // var $basketName = $(formElement).find('[name="basket[name]"]');
        var valid = true;
        formElement.querySelectorAll("[required]").forEach(el => {
            if (!el.value && $(el).is(":visible")) {
                $(el).addClass("shake animated");
                $(el).parents(".form-split").first().addClass("has-error");
                $(el).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    $(el).removeClass('shake animated');
                });
                valid = false;
            } else {
                $(el).parents(".form-split").first().removeClass("has-error");
            }
        });
        // if (!formElement.checkValidity()) {
        //     return false;
        // }
        return valid;
    }

    addLibsBasket() {
        var formElement = document.getElementById('addBasketForm');
        var formData = new FormData(formElement);
        var basketName = document.getElementById('basketName_');

        if (!this.validateForm(formElement)) {
            return;
        }

        fetchJson("/basket/add", formData)
        .then(result => {
            document.getElementById("addBasket").classList.remove("active");
            this.addNewBasket(result, basketName.value);
        });
    }

    setBasketBuilderRelatedInputs(modelName) {
        var basketBuilderData = this.state.basketBuilderData;
        if (basketBuilderData.length > 0) {
            $("#" + modelName + " input[name='basket[value]']").val(basketBuilderData[0].basketValue);
            $("#" + modelName + " input[name='basket[profileId]']").val(basketBuilderData[0].profileId);
        }
    }

    initBasketModal(id="") {
        var typeselects = document.querySelectorAll(".basketTypeSelect");
        typeselects.forEach(s=>{
            s.addEventListener('change', function(e){
                var id = s.id.split('_')[1];
                const mw = document.getElementById("basketManualWeave_" + id);
                const seltype = document.getElementById("basketSelectionType_" + id);
                if (s.value == 'Weave') {
                    document.querySelectorAll(".weaveControl_" + id).forEach(w => w.classList.remove("is-hidden"));
                    document.querySelectorAll(".tierGroupControl_" + id).forEach(w => w.classList.add("is-hidden"));
                    seltype.children[0].disabled = true;
                    seltype.children[0].hidden = true;
                    if (seltype.children[0].selected) {
                        seltype.children[1].selected = true;
                    }
                    if (!mw.classList.contains("hasTask")) {
                        mw.disabled = false;
                    }
                } else {
                    document.querySelectorAll(".weaveControl_" + id).forEach(w => w.classList.add("is-hidden"));
                    document.querySelectorAll(".tierGroupControl_" + id).forEach(w => w.classList.remove("is-hidden"));
                    seltype.children[0].disabled = false;
                    seltype.children[0].hidden = false;
                    mw.disabled = true;
                }
            });
        });
        document.querySelectorAll('[name="basket[ediRequired]"]').forEach(function(el) {
            el.addEventListener('change', function(e) {
                var $modal = $(el).closest("dialog");
                if (el.checked) {
                    $modal.find(".ediContainer.noEdiOverride").show();
                    $modal.find(".basketEdiReset").show();
                } else {
                    $modal.find(".ediContainer.noEdiOverride").hide();
                    $modal.find(".basketEdiReset").hide();
                }
            });
        });
        document.querySelectorAll('[name="basket[stockCohort]"]').forEach(function(el) {
            el.addEventListener('change', function(e) {
                var selectedLot = $(el).find("option:selected").val();
                document.querySelectorAll('[name^="basket[defaults]"]').forEach(function(drop) {
                    $(drop).find('.basketOption').each(function () {
                        var cohort = $(this).data('cohort');
                        if (cohort == selectedLot || cohort == "N/A") {
                            $(this).removeClass("is-hidden"); // Show options where cohort does match (ALSO SHOW OPTIONS WITH NO COHORT)
                        } else if (cohort != "N/A") {
                            $(this).addClass("is-hidden"); // Hide options where cohort doesn't match (DO NOT HIDE OPTIONS WITH NO COHORT)
                        }
                    });
                });
            });
        });
        
        this.setBasketBuilderRelatedInputs("addBasket");

        if (!id) {
            document.querySelector("#addBasket .modal-footer .btn[data-action='confirm']").addEventListener('click', this.addLibsBasket.bind(this));
        }
        document.querySelectorAll(".modal.libs [aria-label='Close']").forEach(el => {
            el.addEventListener('click', e => {
                const modal = e.target.closest(".modal");
                modal.classList.remove("active");
            });
        });
    }

    initForSchoolBasketModal(id="") {
        if (!id) {
            document.querySelector("#addBasket .modal-footer .btn[data-action='confirm']").addEventListener('click', this.addLibsBasket.bind(this));
        }
        
        document.querySelectorAll(".modal [aria-label='Close']").forEach(el => {
            el.addEventListener('click', e => {
                const modal = e.target.closest(".modal");
                modal.classList.remove("active");
            });
        });
    }

    prepForSchoolBasketModal() {
        var ajax = "";
        var $modal = $("#addForSchoolBasket");
        var myIndex = this;

        $modal.find('.customerSearch').autocomplete({
            source: "/basket/getCustomerSuggestions",
            minLength: 2,
            delay: 500,
            select: function (event, ui) {
                var id = ui.item.id;
                var v = ui.item.value;
                var name = ui.item.name;
                var address = ui.item.invAd;

                myIndex.setBasketCustomerInfo($(this).parents('dialog'), id, v, name, address);

                return false;
            }
        });

        // if($modal.find('.searchableSelect').length > 0) {
        //     $modal.find('.searchableSelect').each(function() {
        //         var $searchableSelect = $(this);
        //         new Selectr($(this).get(0)).on('selectr.init', function() {
        //             // Selectr is ready
        //             $searchableSelect.on('change', function(){
        //                 var $parentDialog = $(this).parents('dialog');
        //                 $(this).next('.customerTitle').val($(this).find('option:selected').text());
            
        //                 if(ajax.length) ajax.abort();
        //                 ajax = $.ajax({
        //                     url: "/basket/getCustomerInfo/" + $(this).val(),
        //                     processData:false,
        //                     contentType:false
        //                 }).done(function(res) {
        //                     if(res.invAd) {
        //                         var addressDisplay = res.invAd.join(', ');
        //                     } else {
        //                         var addressDisplay = "No address found";
        //                     }
        //                     $parentDialog.find('.customerTitleInput').val(res.name);
        //                     $parentDialog.find('.customerAddressPreview').text(addressDisplay);
        //                 });
        //             });
        //         });
        //     })
        // }
        if($modal.find('.customerSelect').length > 0) {
            $modal.find('.customerSelect').each(function() {
                var $customerSelect = $(this);
                new Selectr($(this).get(0)).on('selectr.init', function() {
                    // Selectr is ready
                    $customerSelect.on('change', function(){
                        var $parentDialog = $(this).parents('dialog');
                        $(this).next('.customerTitle').val($(this).find('option:selected').text());
            
                        if(ajax.length) ajax.abort();
                        ajax = $.ajax({
                            url: "/basket/getCustomerInfo/" + $(this).val(),
                            processData:false,
                            contentType:false
                        }).done(function(res) {
                            if(res.invAd) {
                                var addressDisplay = res.invAd.join(', ');
                            } else {
                                var addressDisplay = "No address found";
                            }
                            $parentDialog.find('.customerTitleInput').val(res.name);
                            $parentDialog.find('.customerAddressPreview').text(addressDisplay);
                        });
                    });
                });
            })
        }
        let tagsMultiSelectr
        if($modal.find('.tagsMultiSelect').length > 0) {
            $modal.find('.tagsMultiSelect').each(function() {
                let $parentDialog = $(this).parents('dialog');
                let $tagsMultiSelect = $(this);
                
                tagsMultiSelectr = new Selectr($tagsMultiSelect.get(0), {
                    placeholder: "Select tags"
                });

                $tagsMultiSelect.on('change', function(){
                    let selectedTags = $tagsMultiSelect.val();
                    $parentDialog.find('input[name="basketExtras[tags]"]').val(selectedTags.join(', '));
                })
            });
        }

        if($modal.find('.forSchoolsBasketSelectionType').length > 0) {
            $modal.find('.forSchoolsBasketSelectionType').on('change', function() {
                setCookie("FS_AddBasketSelectionType", $(this).val(), 10000);
            });
        }

        if($modal.find('.reapplyRfqButton').length > 0) {
            $modal.find('.reapplyRfqButton').each(function() {
                var $parentDialog = $(this).parents('dialog');
                var $rfqSelect = $(this).siblings('.rfqSelect');
                var $reapplyRfqButton = $(this);

                function applyRfq() {
                    if($rfqSelect.val() > 0) {
                        $reapplyRfqButton.addClass("iconSpin");
                        if(ajax.length) ajax.abort();
                        ajax = $.ajax({
                            url: "/basket/getRfqData/" + $rfqSelect.val(),
                        }).done(function(res) {
                            const rfq = JSON.parse(res)[0];
                            for (const [key, value] of Object.entries(rfq)) {
                                let camelKey = myIndex.camelize(key);
                                let $field = $parentDialog.find('[name$="['+camelKey+']"]');
                                
                                if(!($field.length >= 1)) {
                                    $field = $parentDialog.find('.'+camelKey+'RFQField');
                                }
                                if(camelKey == "notes") {
                                    continue;
                                } else if(camelKey == "basketNotes") {
                                    $field = $parentDialog.find('[name$="[notes]"]');
                                    $field.val(myIndex.stripHtml(value));                                        
                                }else if(camelKey == "tags") {
                                    // $modal.find('.tagsMultiSelect').get(0).setValue(value);
                                    tagsMultiSelectr.setValue(value);
                                    // value.forEach(function(v, i){
                                    //     console.log('option[value="'+v+'"]', $parentDialog.find('option[value="'+v+'"]'))
                                    //     $parentDialog.find('option[value="'+v+'"]').prop('selected', true);
                                    // })
                                } else if($field.is("textarea")) {
                                    $field.val(myIndex.stripHtml(value));
                                } else if($field.is("select")) {
                                    if($field.find('option[value="'+value+'"]').length >= 1) $field.val(myIndex.stripHtml(value));
                                } else {
                                    $field.val(value);
                                }
                            }

                            var emails = rfq.contact_emails?.split(",");

                            if(emails[0]) {
                                $parentDialog.find('input[name="basketExtras[contactEmail]"]').val(emails[0]);
                            }
                            if(emails[1]) {
                                $parentDialog.find('input[name="basketExtras[secondaryContactName]"]').val(emails[1]);
                            }
                            
                            $parentDialog.find('input[name="basketExtras[singleDelivery]"]').prop("checked", rfq.single_delivery);
                            $parentDialog.find('input[name="basketExtras[singleInvoice]"]').prop("checked", rfq.single_invoice);
                            // consolidated_invoice -> consolidatedInvoices IDK HOW IT'S BEEN PLURALISED NOW :'( SORRY!
                            $parentDialog.find('input[name="basketExtras[consolidatedInvoices]"]').prop("checked", rfq.consolidated_invoice);

                            let rfqAddress = new Array();
                            rfqAddress.push(rfq.address?.split(","));
                            rfqAddress.push(rfq.postcode);
                            rfqAddress.push(rfq.country);

                            ajax = $.ajax({
                                url: "/basket/getCustomerInfo/" + rfq.account.value,
                                processData:false,
                                contentType:false
                            }).done(function(res) {
                                var id = res.id;
                                var v = res.value;
                                var name = res.name;
                                var address = res.invAd;
                                
                                if(rfqAddress[0]) {
                                    address = rfqAddress;
                                }

                                myIndex.setBasketCustomerInfo($parentDialog, id, v, name, address);
                                $reapplyRfqButton.removeClass("iconSpin");
                            });
                        });
                    }
                }

                $reapplyRfqButton.on('click', function(){applyRfq()});
                $rfqSelect.on('change', function(){applyRfq()});
                applyRfq();
            });
        }

        document.querySelectorAll(".modal.libs [aria-label='Close']").forEach(el => {
            el.addEventListener('click', e => {
                const modal = e.target.closest(".modal");
                modal.classList.remove("active");
            });
        });
    }

    setBasketCustomerInfo($parentDialog, id, v, name, address) {
        if(address) {
            var addressDisplay = address.join(', ');
        } else {
            var addressDisplay = "No address found";
        }
    
        $parentDialog.find('.customerIdInput').val(id);
        $parentDialog.find('.customerTitleInput').val(name);
        $parentDialog.find('.customerNamePreview').text(name);
        $parentDialog.find('.customerAddressPreview').text(addressDisplay);
        $parentDialog.find('.customerManagementLink').attr("href", "/wx-admin/customerae/" + id).text("Manage " + name + " servicing profiles here.");
        // update what is displayed in the textbox
        this.value = v; 

        var $servicingProfileToApplyContainer = $parentDialog.find('.servicingProfileToApplyContainer');
        var $servicingProfilesSelect = $servicingProfileToApplyContainer.find('.servicingProfileSelect');
        
        if($servicingProfilesSelect.length > 0 && id) {
            $servicingProfilesSelect.html("");
            $servicingProfilesSelect.append($("<option></option>").attr("value", "none").text("Do not apply a profile")); 
            $.ajax({
                url: "/basket/getCustomerServicingProfiles/" + id,
                processData:false,
                contentType:false
            }).done(function(res) {
                const availableServicingProfiles = JSON.parse(res);
                
                for(let i in availableServicingProfiles) {
                    if(availableServicingProfiles[i]["isDefaultProfile"] == "true" && !$parentDialog.find('.rfqSelect').val()) {
                        $servicingProfilesSelect.append($("<option></option>")
                            .attr({
                                value:i, 
                                selected:"selected"
                            })
                            .text(availableServicingProfiles[i]["name"]));
                    } else {
                        $servicingProfilesSelect.append($("<option></option>").attr("value", i).text(availableServicingProfiles[i]["name"])); 
                    }
                }
                // if(availableServicingProfiles) {
                //     $servicingProfileToApplyContainer.stop().slideDown();
                // } else {
                //     $servicingProfileToApplyContainer.stop().slideUp();
                // }
            });
        }
    }

    camelize(str) {
        return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function(match, chr)
        {
            return chr.toUpperCase();
        });
    }

    stripHtml(html) {
        let tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    addBasket() {
        if (Helper.isLibraryUser()) {
            const container = document.getElementById('addBasketModal');
            notifyLoading();
            fetch("/basket/addBasketModal").then(r => r.text()).then(r => {
                stopNotifyLoading();
                container.innerHTML = r;
                
                const modal = document.getElementById("addBasket");
                modal.classList.add("active");
                this.initBasketModal();
                var confirm = document.querySelector("#addBasket .modal-footer .btn[data-action='confirm']");
                reattachEventListener(confirm, 'click', this.addLibsBasket.bind(this));
                $('body').find('#basketDraw').css('left', 'calc(100% - '+($('#basketDrawItems').outerWidth())+'px)');
            });
            return;
        }
        const name = document.getElementById('newBasketName').value;
        var formData = new FormData();
        formData.append("name", name);

        fetchJson('/basket/drawerAdd', formData).then(r => {
            this.addNewBasket(r, name);
            $('body').find('#basketDraw').css('left', 'calc(100% - '+($('#basketDrawItems').outerWidth())+'px)');
        });
    }

    addNewBasket(r, name) {
        var baskets = this.state.baskets;
        baskets[r.basketId] = {
            id: r.basketId,
            name: name,
            quantity: 0,
            total: '0.00'
        };
        this.setState({
            baskets: baskets,
            activeBasketId: r.basketId
        });
        this.channel.postMessage(baskets);
        this.activechannel.postMessage(r.basketId);

        $('.addToBasketSelect').find(":selected").prop('selected', false);

        if (this.wantOrderingGrid !== null) {
            this.openOrderingGrid(r.basketId, this.wantOrderingGrid, this.wantOrderingGridBookshelf, this.wantOrderingGridBasketBuilder);
            this.wantOrderingGrid = null;
            this.wantOrderingGridBookshelf = null;
            this.wantOrderingGridBasketBuilder = null;
        }
    }

    activate(e) {
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'SPAN') {
            return;
        }

        var basketId = e.currentTarget.dataset.id;
        if (basketId == "new") {
            return;
        }

        var url = "/basket/activate/" + basketId;
        fetchJson(url).then(r => {
            this.setState({
                activeBasketId: basketId
            });
            this.activechannel.postMessage(basketId);

            $('.addToBasketSelect').each(function(){
                $(this).find('option[value="'+basketId+'"]').prop('selected', true);
            });

        });
    }

    init(r) {
        this.setState(r);
        // PubSub.pub("basketUpdate", r.baskets, r.activeBasketId, r.bookshelves);
        $('body').find('#basketDraw').css('left', 'calc(100% - '+($('#basketDrawItems').outerWidth())+'px)');
        $('body').find('#basketDraw').css('height', $('#basketDrawItems').height());
        // this.layout();
    }

    // layout() {
    //     let defaultColWidths = [25, 192, 49, 45, 41, 41];
    //     var $table = $('.basketDrawItemsMiddle table'), bodyCellWidths = [];
        
    //     $table.find('tbody tr:first td').each(function(i, e) {
    //         bodyCellWidths[i] = $(e).outerWidth();
    //     });

    //     // Get maximum values from each column width array
    //     let colWidths = bodyCellWidths.map(function(e, i) {
    //         return e > defaultColWidths[i] ? e : defaultColWidths[i];
    //     });

    //     let totalColWidth = colWidths.reduce((a, b) => a + b, 0);
    //     const basketDraw = document.getElementById("basketDraw");
    //     if (basketDraw) {
    //         basketDraw.style.left = `calc(100% - ${parseInt(totalColWidth) + 5}px)`;
    //     }

    //     let $tables = $('#basketDrawItems table');

    //     $tables.each(function(i, table){
    //        $(table).outerWidth(totalColWidth);

    //         // Set the width of thead columns
    //         $(table).find('thead tr').children().each(function(j, v) {
    //             if(j === 1){
    //                 $(v).outerWidth(colWidths[j]);
    //             }else{
    //                 $(v).attr("style", `min-width: ${colWidths[j]}px;`);
    //             }
    //         });   

    //     });
    // }

    forSchoolCheckout(basket) {
        window.location.href = "/checkout/" + basket.id;
        return;
    }

    libsCheckout(basket) {
        window.location.href = "/checkout/" + basket.id;
        return;
    }

    toggleDrawer() {
        this.setState(state => ({
            drawer: state.drawer === "closed" ? "open" : "closed"
        }));
    }

    componentDidMount() {
        this.loadData();
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (prevState.baskets !== this.state.baskets || prevState.activeBasketId !== this.state.activeBasketId) {
            PubSub.pub("basketUpdate", this.state.baskets, this.state.activeBasketId, this.state.bookshelves);
        }

        // we do this so that the basket header/drawer can be rendered in a different part of the DOM
        ReactDOM.render(this.renderBasket(), document.getElementById("basket"));
    }

    renderBasket() {
        const activeBasketId = this.state.activeBasketId;
        const furnitureBasketId = this.state.furnitureBasketId;
        const activeBasket = this.state.baskets[this.isFurniture ? furnitureBasketId : activeBasketId];
        const classes = this.state.drawer + (this.isFurniture ? " furnitureJade" : "");

        // Check if tracking is already set, if not (adn we have a basket) try and set it
        if(!document.getElementById('dotdigitalCartTracker') && activeBasket) {
            Helper.trackBasket(activeBasket)
        }

        return (
            <>
                <BasketHeader loaded={this.state.loaded} basket={activeBasket} isFurniture={this.isFurniture} link={activeBasket ? activeBasket.checkout : null} />
                {!this.isManageBaskets && !this.isFurniture && <div id="basketDraw" className={classes}>
                    {this.state.loaded && <Drawer baskets={this.state.baskets} activate={this.activate} rename={this.rename} delete={this.onDelete} addBasket={this.addBasket} activeBasketId={this.state.activeBasketId} onChange={this.changeName} libsCheckout={this.libsCheckout.bind(this)} forSchoolCheckout={this.forSchoolCheckout.bind(this)} toggleDrawer={this.toggleDrawer.bind(this)} furnitureBasketId={furnitureBasketId} />}
                </div>}
            </>
        );
    }

    render() {
        const path = window.location.pathname.split("/");
        if (path[1] == "logout") {
            return null;
        }
        return (
            <>
                {Helper.isLibraryUser() && <OrderingGridModal fromBookshelf={this.state.bookshelfId} basketBuilderData={this.state.basketBuilderData} data={this.getOrderingGridData()} getItemServicingTotal={this.getItemServicingTotal.bind(this)} />}
                <AddEntityModal id="addBookshelf" heading="Add bookshelf" route="/bookshelves" name="" callback={this.addBookshelfCallback.bind(this)} />
                <ErrorNotification />
                <LoadingNotification />
            </>
        );
    }
}

export default App;